import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

// eslint-disable-next-line
const ReactQuill = dynamic(() => import('react-quill'), {
  ssr: false,
});

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, false] }],
    ['bold', 'italic', 'underline'],
    [{ align: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'align',
];

class HtmlEditor extends PureComponent {
  static get propTypes() {
    return {
      onChange: PropTypes.func.isRequired,
      value: PropTypes.string,
      name: PropTypes.string.isRequired,
    };
  }

  static get defaultProps() {
    return {
      value: '',
    };
  }

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value, delta, source, editor) {
    const { onChange, name } = this.props;
    const plain = editor.getText().replace('\n', '');
    if (!plain) {
      onChange(name, '');
    } else {
      onChange(name, value);
    }
  }

  render() {
    const { value } = this.props;
    return (
      <div className="text-editor">
        <ReactQuill
          theme="snow"
          value={value}
          onChange={this.handleChange}
          modules={modules}
          formats={formats}
        />
      </div>
    );
  }
}

const mapStateToProps = (store, { onChange, value, name }) => ({
  onChange,
  name,
  value,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(HtmlEditor);
